import React from "react";
import { Form } from "react-bootstrap";
const Upload = props => {
  const id = props.id.toString()

  return (
    <div key={props.key} className={`${props.className} custom-file`}>
      <Form.Control
        required={props.required}
        className="custom-file-input"
        id={props.id}
        onChange={props.onChange}
        type="file"
        accept={props.accept}
        key={props.uploadKey}
        title="Odaberi datoteku"
      />
      <label
        style={{ borderColor: props.style, zIndex: 1 }}
        className="custom-file-label"
        htmlFor={props.id}
      >
        {(props.selectedFiles.length === 0 && (
          <span className="d-inline-block text-truncate w-75">
            Odaberite datoteku...
          </span>
        )) ||
          (!!props.selectedFiles.find(element => {
            return element.id === id;
          }) &&
            props.selectedFiles.map(
              element =>
                element.id === props.id && (
                  <span className="d-inline-block text-truncate w-75">
                    {element.file.name ? element.file.name : element.file.nazDok}
                  </span>
                )
            )) || <p>Odaberite datoteku...</p>}
      </label>
    </div>
  );
};

export default Upload;
